import SinglePage from "../single-page/single-page";
import styled from "styled-components";
import { Helmet } from "react-helmet";

const Big404 = styled.p`
  font-size: 24px;
  font-weight: bold;
`;

function NotFound() {
    return (
        <SinglePage title="">
            <Helmet>
                <title>404 - Strona nie istnieje</title>
                <meta name="description" content="Strona, której szukasz, nie istnieje. Sprawdź poprawność adresu lub wróć do strony głównej." />
                <meta name="keywords" content="404, nie znaleziono, strona nie istnieje, błąd, geoksiegi" />
            </Helmet>
            <Big404>404</Big404>
            <p>Strona, której szukasz, nie istnieje</p>
        </SinglePage>
    );
}

export default NotFound;
